/* Addictimon theme JS — nav, gallery, qty, AJAX add-to-cart */
(function () {
  'use strict';

  // Mobile nav
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.site-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery (2 Sep 2026): scroll-snap track = native swipe on touch; mouse drag, arrows, thumbs, keys; hover-zoom on fine pointers
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gallery__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__thumbs button'));
    var thumbsEl = gallery.querySelector('.gallery__thumbs');
    var counter = gallery.querySelector('[data-count]');
    var n = slides.length, cur = 0, raf = null, eagerDone = false;
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function eager() {
      if (eagerDone) return;
      eagerDone = true;
      track.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
    }
    function setCurrent(i) {
      if (i === cur) return;
      cur = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-current', k === i); });
      thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = String(i + 1);
      if (thumbsEl && thumbs[i]) {
        var t = thumbs[i];
        var left = t.offsetLeft - (thumbsEl.clientWidth - t.offsetWidth) / 2;
        thumbsEl.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    function go(i, instant) {
      i = Math.max(0, Math.min(n - 1, i));
      eager();
      track.classList.remove('is-dragging');
      track.scrollTo({ left: i * track.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      setCurrent(i);
    }
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        setCurrent(Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w))));
      });
    });
    var prev = gallery.querySelector('[data-prev]'), next = gallery.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    thumbs.forEach(function (btn, k) { btn.addEventListener('click', function () { go(k); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });
    track.addEventListener('touchstart', eager, { passive: true });
    window.addEventListener('resize', function () { track.scrollTo({ left: cur * track.clientWidth, behavior: 'auto' }); });

    // Mouse drag (touch scrolls natively). Drag sets is-dragging (snap off) so the track follows the pointer 1:1.
    if (window.PointerEvent) {
      var down = false, moved = false, x0 = 0, s0 = 0, i0 = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft; i0 = cur;
        eager();
        e.preventDefault();
      });
      track.addEventListener('pointermove', function (e) {
        if (!down || e.pointerType !== 'mouse') return;
        var dx = e.clientX - x0;
        if (!moved && Math.abs(dx) > 6) {
          moved = true;
          track.classList.add('is-dragging');
          slides.forEach(function (s) { s.classList.remove('is-zoom'); });
        }
        if (moved) track.scrollLeft = s0 - dx;
      });
      function release(e) {
        if (!down) return;
        down = false;
        if (!moved) return;
        // Commit relative to the slide the drag STARTED on (cur already moved with the scroll), so one drag = one step
        // unless the pointer really crossed further.
        var dx = e.clientX - x0, w = track.clientWidth || 1, target = i0;
        if (dx < -40) target = Math.max(i0 + 1, Math.round((s0 - dx) / w));
        else if (dx > 40) target = Math.min(i0 - 1, Math.round((s0 - dx) / w));
        go(target);
      }
      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('pointerleave', release);
    }

    // Hover-zoom: desktop only; zoom origin follows the cursor; hi-res source swapped in on first hover
    if (fine) {
      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        if (!img) return;
        slide.addEventListener('pointerenter', function () {
          if (track.classList.contains('is-dragging')) return;
          if (img.dataset.zoom && !img.dataset.zoomed) {
            img.dataset.zoomed = '1';
            var hi = new Image();
            hi.onload = function () { img.srcset = ''; img.src = img.dataset.zoom; };
            hi.src = img.dataset.zoom;
          }
          slide.classList.add('is-zoom');
        });
        slide.addEventListener('pointermove', function (e) {
          if (!slide.classList.contains('is-zoom')) return;
          var r = slide.getBoundingClientRect();
          var px = ((e.clientX - r.left) / r.width) * 100, py = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = Math.max(0, Math.min(100, px)) + '% ' + Math.max(0, Math.min(100, py)) + '%';
        });
        slide.addEventListener('pointerleave', function () { slide.classList.remove('is-zoom'); });
      });
    }
  });

  // Quantity steppers. Cart forms (data-cart-update): the minus button at 1 goes to 0 and the line leaves — there is NO remove
  // control by design (Thor, 2 Sep 2026: a Remove button "encourages people to do what we don't want"). The removed line is
  // stashed (sessionStorage) and offered back under the cart as "Put it back". Product / upsell steppers floor at 1.
  var STASH = 'addictimon_removed';
  function readStash() { try { return JSON.parse(sessionStorage.getItem(STASH) || '[]') || []; } catch (e) { return []; } }
  function writeStash(list) { try { sessionStorage.setItem(STASH, JSON.stringify(list)); } catch (e) {} }
  function stashLine(line) {
    if (!line || !line.dataset.variantId) return;
    var img = line.querySelector('img');
    var list = readStash().filter(function (x) { return String(x.id) !== String(line.dataset.variantId); });
    list.unshift({ id: line.dataset.variantId, qty: parseInt(line.dataset.qty, 10) || 1, title: line.dataset.title || '',
      price: line.dataset.price || '', img: img ? (img.currentSrc || img.src || '') : '', upsell: line.dataset.upsell === '1' });
    writeStash(list.slice(0, 6));
  }
  function applyCartQty(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 0) v = 0;
    var capAttr = parseInt(input.max, 10);
    if (capAttr > 0 && v > capAttr) v = capAttr;
    input.value = v;
    if (String(v) === input.dataset.applied) return;
    input.dataset.applied = String(v);
    if (v === 0) stashLine(input.closest('.cart-line'));
    input.form.submit();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty button[data-dir]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    if (!input || input.disabled) return;
    var isCart = !!(input.form && input.form.dataset.cartUpdate);
    var cur = parseInt(input.value, 10);
    if (isNaN(cur)) cur = 1;
    var v = cur + (btn.dataset.dir === 'up' ? 1 : -1);
    var capAttr = parseInt(input.max, 10);
    if (capAttr > 0 && v > capAttr) v = capAttr;
    if (v < (isCart ? 0 : 1)) v = isCart ? 0 : 1;
    if (v === cur) return;
    input.value = v;
    if (isCart) applyCartQty(input);
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.form || !input.form.dataset.cartUpdate || input.name !== 'updates[]') return;
    applyCartQty(input);
  });
  document.addEventListener('keydown', function (e) {
    var input = e.target;
    if (e.key !== 'Enter' || !input.form || !input.form.dataset.cartUpdate || input.name !== 'updates[]') return;
    e.preventDefault();
    applyCartQty(input);
  });

  // "Changed your mind? Put it back" — the recovery row under the cart lines (also shown on the empty cart)
  var restoreBox = document.getElementById('cartRestore');
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function renderRestore() {
    if (!restoreBox) return;
    var inCart = {};
    document.querySelectorAll('.cart-line[data-variant-id]').forEach(function (l) { inCart[l.dataset.variantId] = true; });
    var list = readStash().filter(function (x) { return !inCart[x.id]; });
    writeStash(list);
    if (!list.length) { restoreBox.hidden = true; restoreBox.innerHTML = ''; return; }
    restoreBox.innerHTML = '<p class="cart-restore__head">Changed your mind?</p>' + list.map(function (x) {
      return '<div class="cart-restore__row">' +
        (x.img ? '<img src="' + escapeHtml(x.img) + '" alt="" width="48" height="48" loading="lazy">' : '') +
        '<span class="cart-restore__info"><b>' + escapeHtml(x.title) + '</b><span>' + (x.qty > 1 ? x.qty + ' × ' : '') + escapeHtml(x.price) + '</span></span>' +
        '<button type="button" class="btn btn--ink cart-restore__btn" data-restore-id="' + escapeHtml(x.id) + '" data-restore-qty="' + (parseInt(x.qty, 10) || 1) + '"' + (x.upsell ? ' data-restore-upsell="1"' : '') + '>Put it back</button></div>';
    }).join('');
    restoreBox.hidden = false;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-restore-id]');
    if (!b || b.disabled) return;
    b.disabled = true;
    b.textContent = 'Adding…';
    var restoreBody = { id: parseInt(b.dataset.restoreId, 10), quantity: parseInt(b.dataset.restoreQty, 10) || 1 };
    if (b.dataset.restoreUpsell === '1') restoreBody.properties = { _upsell: '1' }; /* an offer line comes back as an offer line, deal included */
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(restoreBody) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return b.dataset.restoreUpsell === '1' ? attachOfferCode(OFFER_CODE) : null; })
      .then(function () {
        writeStash(readStash().filter(function (x) { return String(x.id) !== String(b.dataset.restoreId); }));
        location.reload();
      })
      .catch(function () { b.disabled = false; b.textContent = 'Put it back'; });
  });
  renderRestore();

  // Offer code handling (2 Sep 2026, the "discount for no reason" leak). BIGTHREE10 is attached to the cart ONLY by the
  // offer's Add button, and every page load drops it again unless a Big Three line that came from the offer (hidden
  // _upsell property) is still in the cart. Never via /discount/CODE: that sets a 3-month cookie that discounted every
  // later Big Three, offer or not. Attaching through /cart/update.js sets no cookie.
  var OFFER_CODE = 'BIGTHREE10';
  function cartCodes(cart) {
    return (cart.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); }).filter(Boolean);
  }
  function hasOfferLine(cart) {
    return (cart.items || []).some(function (it) {
      return it.handle === 'big-three-pack' && it.properties && it.properties._upsell === '1';
    });
  }
  function setCodes(codes) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') }) }).catch(function () {});
  }
  function attachOfferCode(code) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var codes = cartCodes(cart);
      if (codes.indexOf(code) === -1) codes.push(code);
      return setCodes(codes);
    }).catch(function () {});
  }
  function sweepOfferCode(cart) {
    var codes = cartCodes(cart);
    if (codes.indexOf(OFFER_CODE) === -1 || hasOfferLine(cart)) return Promise.resolve(false);
    return setCodes(codes.filter(function (c) { return c !== OFFER_CODE; })).then(function () { return true; });
  }

  // AJAX add to cart
  function updateCartCount() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-cart__count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return sweepOfferCode(cart).then(function (swept) {
          /* the cart page shows totals: re-render once the stray code is gone */
          if (swept && document.querySelector('form[data-cart-update]')) location.reload();
        });
      })
      .catch(function () {});
  }
  // 2 Sep 2026: an add that fails (stock cap hit, sold out mid-session, network) shows Shopify's own reason next to the button.
  // Before this it blind-redirected to /cart with nothing added — the customer saw an empty cart and no explanation (audit: SALES-BLOCKING).
  function showAddError(form, msg) {
    var el = form.querySelector('.add-error');
    if (!el) { el = document.createElement('p'); el.className = 'add-error'; el.setAttribute('role', 'alert'); form.appendChild(el); }
    el.textContent = msg || "Couldn't add that to your cart. Please try again.";
    el.hidden = false;
  }
  function clearAddError(form) { var el = form.querySelector('.add-error'); if (el) el.hidden = true; }

  // 2 Nov 2026 (T2117, Thor: "they can just buy a maximum of 4"): God Pack Premium is capped at 4 per order. Every add path asks /cart.js first and
  // clamps to what is left under the cap, so adding again can never push the cart line above 4 (the cart page input is capped by main-cart.liquid).
  var GP_VID = '60290643067214', GP_MAX = 4;
  function gpAllowed(vid, qty) {
    if (String(vid) !== GP_VID) return Promise.resolve(qty);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var have = 0;
      (c.items || []).forEach(function (it) { if (String(it.variant_id) === GP_VID) have += it.quantity; });
      return Math.max(0, Math.min(qty, GP_MAX - have));
    }).catch(function () { return Math.min(qty, GP_MAX); });
  }
  var GP_MSG = 'Max 4 per order. This pack is already in your cart at 4.';

  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      clearAddError(form);
      var fd = new FormData(form);
      gpAllowed(fd.get('id'), parseInt(fd.get('quantity'), 10) || 1)
        .then(function (q) {
          if (q <= 0) throw new Error(GP_MSG);
          fd.set('quantity', q);
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd });
        })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'add failed');
            return j;
          });
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          updateCartCount();
          openUpsellModal();
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
        })
        .catch(function (err) {
          btn.textContent = original; btn.disabled = false;
          showAddError(form, err && err.message !== 'add failed' && err.message !== 'Failed to fetch' ? err.message : '');
        });
    });
  });

  // Upsell offer, non-GBP markets (2 Sep 2026): BIGTHREE10 is a fixed £10 and converts at the live rate at checkout,
  // so the offer shows the converted saving in the visitor's currency (never "£10", never a minor-units guess). Shopify.currency is on every page.
  function parseMoney(str) {
    var t = String(str).replace(/[^0-9.,]/g, '');
    var lc = t.lastIndexOf(','), ld = t.lastIndexOf('.');
    if (lc > ld && t.length - lc - 1 <= 2) { t = t.split('.').join('').replace(',', '.'); }
    else if (ld > -1 && lc === -1 && t.length - ld - 1 === 3) { t = t.split('.').join(''); }
    else { t = t.split(',').join(''); }
    return parseFloat(t);
  }
  function localizeDealLines(root) {
    if (!window.Shopify || !window.Shopify.currency) return;
    var cur = window.Shopify.currency.active, rate = parseFloat(window.Shopify.currency.rate);
    if (!cur || cur === 'GBP' || !(rate > 0)) return;
    var fmt;
    try { fmt = new Intl.NumberFormat('en', { style: 'currency', currency: cur }); } catch (err) { return; }
    (root || document).querySelectorAll('[data-deal-line]').forEach(function (line) {
      var gbp = parseInt(line.dataset.dealGbp, 10), price = parseMoney(line.dataset.offerPrice);
      if (!(gbp > 0) || !(price > 0)) return;
      var off = (gbp / 100) * rate, deal = price - off;
      if (!(deal > 0)) return;
      var priceEl = line.querySelector('[data-deal-price]');
      var card = line.closest('.upsell-offer');
      var textEl = card ? card.querySelector('[data-deal-text]') : null;
      if (priceEl) {
        priceEl.innerHTML = '<b class="upsell-offer__price upsell-offer__price--deal">' + fmt.format(deal) + '</b> <s>' + fmt.format(price) + '</s>';
      }
      if (textEl) {
        textEl.textContent = fmt.format(off) + ' off every pack in this offer, applied automatically at checkout. Stacks with your discount code.';
        textEl.hidden = false;
      }
    });
  }
  localizeDealLines(document);

  // Upsell engine (see UPSELL_SYSTEM.md): post-add offer modal + one-tap offer adds
  var upsellModal = document.getElementById('upsellModal');

  function openUpsellModal() {
    if (!upsellModal) return;
    upsellModal.hidden = false;
    document.documentElement.classList.add('upsell-open');
  }
  function closeUpsellModal() {
    if (!upsellModal) return;
    upsellModal.hidden = true;
    document.documentElement.classList.remove('upsell-open');
  }
  if (upsellModal) {
    upsellModal.addEventListener('click', function (e) {
      if (e.target === upsellModal || e.target.closest('[data-upsell-close]')) closeUpsellModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeUpsellModal();
    });
  }

  // One-tap offer add — works in the cart strip and inside the modal (event delegation)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var card = btn.closest('.upsell-offer');
    var qtyInput = card ? card.querySelector('[data-upsell-qty]') : null;
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var uMax = qtyInput ? parseInt(qtyInput.max, 10) : NaN;
    if (uMax > 0 && qty > uMax) qty = uMax;
    var code = btn.dataset.upsellDiscount;
    gpAllowed(btn.dataset.upsellAdd, qty)
      .then(function (q) {
        if (q <= 0) throw new Error('capped');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(btn.dataset.upsellAdd, 10), quantity: q, properties: { _upsell: '1' } })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return code ? attachOfferCode(code) : null; })
      .then(function () {
        if (btn.closest('.upsell-modal')) {
          btn.textContent = 'Added ✓';
          updateCartCount();
          nextModalOffer(card);
        } else {
          location.reload(); /* cart page: re-render totals + next offer rung */
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  });

  // The modal "goes round": after an Add it fetches this page again (the cart now holds the added pack, so Liquid
  // resolves the next rung) and swaps the offer card in place. No rung left = the card goes and the modal just says Added.
  function nextModalOffer(card) {
    if (!card) return;
    fetch(location.pathname + location.search, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('fetch failed'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#upsellModal .upsell-offer');
        if (!fresh || fresh.querySelector('[data-upsell-add]') === null) { card.remove(); return; }
        var node = document.importNode(fresh, true);
        card.replaceWith(node);
        localizeDealLines(node);
      })
      .catch(function () { /* keep "Added" */ });
  }

  updateCartCount();
})();

/* Country / currency (2 Sep 2026). One domain serves every market, so Shopify renders the primary (GB) market
   until a country is chosen. Manual pick = remembered for good; auto-detect runs once per tab, never over a manual pick. */
(function () {
  'use strict';
  var MANUAL = 'addictimon_country_manual';
  var AUTO = 'addictimon_country_auto';
  var form = document.getElementById('AddictimonLocalizationForm');
  var select = form && form.querySelector('select[name="country_code"]');
  if (!form || !select) return;

  select.addEventListener('change', function () {
    try { localStorage.setItem(MANUAL, select.value); } catch (e) {}
    form.submit();
  });

  /* No storage = no auto-detect (nothing to stop it re-firing on every page). One attempt per tab, flagged BEFORE the fetch. */
  var manual, tried;
  try { manual = localStorage.getItem(MANUAL); tried = sessionStorage.getItem(AUTO); sessionStorage.setItem(AUTO, '1'); } catch (e) { return; }
  if (manual || tried) return;
  if (!window.Shopify || !window.Shopify.country || !window.fetch) return;
  if (/bot|crawl|spider|slurp|facebookexternalhit|preview|lighthouse/i.test(navigator.userAgent)) return;

  var root = (window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
      if (!c) return;
      c = String(c).toUpperCase();
      if (c === window.Shopify.country) return;
      if (!select.querySelector('option[value="' + c + '"]')) return;
      select.value = c;
      form.submit();
    })
    .catch(function () {});
})();
